//
//
//
//
//
//

import { mapActions } from 'vuex';

export default {
  name: 'callback',
  methods: {
    ...mapActions('user', [
      'setToken',
      'setUserName',
      'setUserEngName',
      'setUserIdNumber',
      'setEmail',
      'setAvatarUrl',
      'setUserCategory',
    ]),
    ...mapActions('dialog', ['setLoginShow']),
    handleLogin(data) {
      this.setToken(data);
      this.setUserName(data.name || '');
      this.setUserEngName(data.engName || '');
      this.setUserIdNumber(data.idNumber || '');
      this.setEmail(data.email || '');
      this.setAvatarUrl(data.url || '');
      this.setUserCategory(data.category || 0);
    },
  },
  head() {
    return {
      title: 'STEP1NE 登錄驗證 - 安全登錄',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'STEP1NE 安全登錄驗證',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '正在登錄STEP1NE。此頁面用於安全驗證您的用戶身份，以保護您的賬戶和個人資訊。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            '正在登錄STEP1NE。此頁面用於安全驗證您的用戶身份，以保護您的賬戶和個人資訊。',
        },
      ],
    };
  },
  mounted() {
    if (process.client) {
      if (this.$route.query.error) {
        this.$router.replace('/');
        return this.$message.error(this.$route.query.error);
      }
      fetch(
        `https://${
          window.location.hostname === 'step1ne.com' ? '' : 'dev-'
        }openid.step1ne.com/user/me`,
        {
          method: 'GET',
          headers: {
            authorization: `Bearer ${this.$route.query.token}`,
          },
        },
      ).then(response => {
        response.json().then(json => {
          if (json.code !== 100) {
            this.$router.replace('/');
            this.setLoginShow(true);
            setTimeout(() => {
              this.$message.error(json.message);
            }, 200);
            return Promise.reject(json);
          }
          this.handleLogin(json.data);
          this.$message.success('登入成功!');
          this.$router.replace('/');
          return json;
        });
      });
    }
  },
};
